/* Code für Text-Clamp */

document.querySelectorAll('.read-more').forEach(section => {

  let image = section.querySelector('.image-block img');

  if(!image){
    image = section.querySelector('.image-block > *:first-child');
  }
  const textBlock = section.querySelector('.group-block');

  if(!image || !textBlock) return;

  function applyClamp(){

    const btn = section.querySelector(".read-more-btn")

    if(btn && btn.getAttribute("aria-expanded") === "true"){
      return
    }

    const imgHeight = image.offsetHeight;

    textBlock.style.maxHeight = imgHeight + "px";
    textBlock.classList.add("truncated");

    if(!section.querySelector(".read-more-btn")){

      const btn = document.createElement("button");
      btn.className = "read-more-btn paragraph";
      btn.innerText = "Mehr anzeigen...";
      btn.setAttribute("aria-expanded", "false");

      btn.onclick = () => {

        const expanded = btn.getAttribute("aria-expanded") === "true";

        if(!expanded){
          btn.setAttribute("aria-expanded", "true");
          textBlock.style.maxHeight = "none";
          btn.style.position = "initial";
          btn.innerText = "Weniger anzeigen";
        } else {
          btn.setAttribute("aria-expanded", "false");
          textBlock.style.maxHeight = image.offsetHeight + "px";
          btn.style.position = "absolute";
          btn.innerText = "Mehr anzeigen...";
          textBlock.scrollIntoView({ behavior: "smooth", block: "nearest" });
        }

      };

      textBlock.appendChild(btn);
    }

  }

  applyClamp();
  image.onload = applyClamp;
  window.addEventListener("resize", applyClamp);

});


/* Code für Slider */

document.querySelectorAll('[data-slider]').forEach(slider => {

  const track = slider.querySelector('.slider-track')
  const slides = Array.from(track.children)

  const prev = slider.querySelector('.prev')
  const next = slider.querySelector('.next')
  const dotsContainer = slider.querySelector('.slider-dots')

  const visible = parseInt(slider.dataset.desktop) || 1

  slider.style.setProperty('--slides', visible)

  let index = visible
  let dots = []

  /* ---------- CLONE SLIDES FOR INFINITE LOOP ---------- */

  const prepend = slides.slice(-visible)
  const append = slides.slice(0, visible)

  prepend.forEach(slide=>{
    const clone = slide.cloneNode(true)
    clone.classList.add('clone')
    track.prepend(clone)
  })

  append.forEach(slide=>{
    const clone = slide.cloneNode(true)
    clone.classList.add('clone')
    track.append(clone)
  })

  const allSlides = Array.from(track.children)

  /* ---------- CREATE DOTS ---------- */

  if(dotsContainer){

    slides.forEach((_, i)=>{

      const dot = document.createElement('button')

      dot.addEventListener('click', ()=>{
        index = i + visible
        update()
        updateDots()
      })

      dotsContainer.appendChild(dot)
      dots.push(dot)

    })

  }

  /* ---------- SLIDE WIDTH ---------- */

  let slideWidth

  function measure(){
    slideWidth = allSlides[0].getBoundingClientRect().width + 20
  }

  /* ---------- UPDATE SLIDER ---------- */

  function update(animate=true){

    if(!animate){
      track.style.transition='none'
    }else{
      track.style.transition='transform .4s ease'
    }

    track.style.transform = `translateX(${-slideWidth * index}px)`

    updateDots()
  }

  /* ---------- UPDATE DOTS ---------- */

  function updateDots(){

    if(!dots.length) return

    let realIndex = index - visible

    if(realIndex >= slides.length) realIndex = 0
    if(realIndex < 0) realIndex = slides.length - 1

    dots.forEach((dot,i)=>{
      dot.classList.toggle('active', i === realIndex)
    })

  }

  /* ---------- INIT AFTER LAYOUT ---------- */

  requestAnimationFrame(()=>{
    measure()
    update(false)
  })

  window.addEventListener('resize', ()=>{
    measure()
    update(false)
  })

  /* ---------- NAVIGATION ---------- */

  function nextSlide(){
    index++
    update()
  }

  function prevSlide(){
    index--
    update()
  }

  next?.addEventListener('click', nextSlide)
  prev?.addEventListener('click', prevSlide)

  /* ---------- LOOP FIX ---------- */

  track.addEventListener('transitionend', ()=>{

    if(index >= slides.length + visible){
      index = visible
      update(false)
    }

    if(index < visible){
      index = slides.length + visible - 1
      update(false)
    }

  })

  /* ---------- TOUCH SWIPE ---------- */

let startX = 0
let currentX = 0
let isDragging = false

track.addEventListener('touchstart', e => {

  startX = e.touches[0].clientX
  isDragging = true
  track.style.transition = 'none'

})

track.addEventListener('touchmove', e => {

  if(!isDragging) return

  currentX = e.touches[0].clientX
  const diff = currentX - startX

  track.style.transform = `translateX(${(-slideWidth * index) + diff}px)`

})

track.addEventListener('touchend', () => {

  if(!isDragging) return
  isDragging = false

  const diff = currentX - startX

  if(Math.abs(diff) > slideWidth * 0.2){

    if(diff < 0){
      index++
    }else{
      index--
    }

  }

  update()

})

})


